import { TagColorKind, TagView } from "generated/graphql";

// Adding a random suffix to avoid conflict with a theoretical 'starred' tag
export const STARRED = "starred_lwspcgbduwluvplp";
export const UNTAGGED = "untagged_qqntzppifydnsuaz";

export const STARRED_RANK = Number.MIN_SAFE_INTEGER;
export const UNTAGGED_RANK = Number.MAX_SAFE_INTEGER;

// Cribbed from backend so we can have a default for fake tags (untagged, starred)
export const GRAY_COLOR_VALUE = "#4b5563";

export const STARRED_ENTRY: TagView = {
  displayName: "Starred",
  systemName: STARRED,
  color: TagColorKind.Gray,
  colorValue: GRAY_COLOR_VALUE,
  fields: [],
  filteredByDefaultFields: [],
  readOnlyFields: [],
  supportOnlyFields: [],
  rank: STARRED_RANK,
};
export const UNTAGGED_ENTRY: TagView = {
  displayName: "None",
  systemName: UNTAGGED,
  color: TagColorKind.Gray,
  colorValue: GRAY_COLOR_VALUE,
  fields: [],
  filteredByDefaultFields: [],
  readOnlyFields: [],
  supportOnlyFields: [],
  rank: UNTAGGED_RANK,
};
